export default {
    gray: 'gray',
    red:  'red',
};
